import type { Modal, ModalType } from '@components/modal/Modal.type';
import type { ModalPosition } from '@stores/modalStore';
import useModalStore from '@stores/modalStore';

const useModalHook = () => {
  const store = useModalStore();

  const storeOpenModal = (modal: Modal, pos: ModalPosition = 'default') => {
    return new Promise((resolve) => {
      const onConfirm = <T>(...arg: T[]) => {
        modal?.props?.onConfirm?.(...arg);
        return resolve('confirm');
      };

      const onCancel = () => {
        modal?.props?.onCancel?.();
        return resolve('cancel');
      };

      const newModal = {
        ...modal,
        props: {
          ...modal.props,
          onConfirm,
          onCancel,
        },
      };

      store.openModal(newModal, pos);
    });
  };

  const storeCloseModal = (modalType: ModalType, pos: ModalPosition = 'default') => {
    store.closeModal(modalType, pos);
  };

  const storeCloseAllModal = () => {
    store.closeAllModal();
  };

  return {
    openModal: storeOpenModal,
    closeModal: storeCloseModal,
    closeAllModal: storeCloseAllModal,
  };
};

export default useModalHook;
